const SharedFormActions = {
  LOADED: "shared-form/loaded",
  RESPONSE_LOADED: "shared-form-response/loaded",
  SUBMISSION_LOADED: "shared-form-submission/loaded",
  PROMPT_VERSION_LOADED: "shared-prompt-version/loaded",
};

export default SharedFormActions;
